import { useState, useCallback } from "react"

export function useDragAndDrop(selectedItems, setSelectedItems, getCategoryById, moveSelectedToParent) {
  const [dragOverId, setDragOverId] = useState(null)

  const handleDragStart = useCallback(
    (e, categoryId) => {
      if (!selectedItems.includes(categoryId)) setSelectedItems([categoryId])
      e.dataTransfer.effectAllowed = "move"

      const itemsToShow = selectedItems.includes(categoryId) ? selectedItems : [categoryId]
      const preview = document.createElement("div")
      preview.style.cssText = `
        position:absolute;top:-9999px;
        background:#1e293b;border:1px solid #6366f1;border-radius:10px;
        padding:10px 14px;box-shadow:0 8px 24px rgba(0,0,0,.5);
        display:flex;flex-direction:column;gap:6px;max-width:280px;
      `
      const label = document.createElement("div")
      label.textContent = `${itemsToShow.length} node${itemsToShow.length > 1 ? "s" : ""}`
      label.style.cssText = "font-size:11px;color:#94a3b8;font-weight:600;text-transform:uppercase;"
      preview.appendChild(label)

      const chips = document.createElement("div")
      chips.style.cssText = "display:flex;flex-wrap:wrap;gap:5px;"
      itemsToShow.slice(0, 3).forEach((id) => {
        const cat = getCategoryById(id)
        if (!cat) return
        const chip = document.createElement("div")
        chip.style.cssText = `
          display:flex;align-items:center;gap:5px;padding:3px 9px;
          background:#334155;border-radius:5px;font-size:12px;color:#e2e8f0;
        `
        const dot = document.createElement("span")
        dot.style.cssText = `width:7px;height:7px;border-radius:50%;background:${cat.color};flex-shrink:0;`
        const text = document.createElement("span")
        text.textContent = cat.name
        text.style.cssText = "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:130px;"
        chip.append(dot, text)
        chips.appendChild(chip)
      })
      if (itemsToShow.length > 3) {
        const more = document.createElement("div")
        more.textContent = `+${itemsToShow.length - 3}`
        more.style.cssText =
          "padding:3px 9px;background:#6366f1;border-radius:5px;font-size:12px;color:#fff;"
        chips.appendChild(more)
      }
      preview.appendChild(chips)
      document.body.appendChild(preview)
      e.dataTransfer.setDragImage(preview, 0, 0)
      setTimeout(() => document.body.removeChild(preview), 0)
    },
    [selectedItems, setSelectedItems, getCategoryById]
  )

  const handleDragOver = useCallback(
    (e, categoryId) => {
      e.preventDefault()
      e.dataTransfer.dropEffect = selectedItems.includes(categoryId) ? "none" : "move"
    },
    [selectedItems]
  )

  const handleDragEnter = useCallback(
    (e, categoryId) => {
      e.preventDefault()
      if (!selectedItems.includes(categoryId)) setDragOverId(categoryId)
    },
    [selectedItems]
  )

  const handleDragLeave = useCallback((e) => {
    if (e.currentTarget === e.target) setDragOverId(null)
  }, [])

  const handleDrop = useCallback(
    (e, targetId) => {
      e.preventDefault()
      setDragOverId(null)
      if (selectedItems.length > 0 && !selectedItems.includes(targetId))
        moveSelectedToParent(targetId)
    },
    [selectedItems, moveSelectedToParent]
  )

  const handleDragEnd = useCallback(() => setDragOverId(null), [])

  return {
    dragOverId,
    handleDragStart,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    handleDragEnd,
  }
}
